export default __webpack_public_path__ + "2d8a86f3ac50ea500d1b05d2e16ecbf4.otf";